export class Drag {
    constructor(el, callback, returnAbsolute) {
        this.domEvents = [];
        this.dragging = false;
        this.lastEvent = null;
        this.startX = 0;
        this.startY = 0;
        this.callback = callback;
        this.returnAbsolute = returnAbsolute;
        this.enable(el);
        return this;
    }

    onMove(el, e, info, starting) {
        this.lastEvent = e;

        if (starting) {
            if (this.returnAbsolute) {
                const bounds = el.getBoundingClientRect();
                this.startX = info.clientX - bounds.left;
                this.startY = info.clientY - bounds.top;
            }
            this.dragging = true;
        }

        if (!this.dragging) {
            return;
        }

        if (e.cancelable) {
            e.stopPropagation();
            e.preventDefault();
        }

        const bounds = el.getBoundingClientRect();
        let deltaX = (info.clientX - this.startX - bounds.left);
        let deltaY = (info.clientY - this.startY - bounds.top);

        if (!this.returnAbsolute) {
            deltaX = Math.min(1, Math.max(0, deltaX / bounds.width));
            deltaY = Math.min(1, Math.max(0, deltaY / bounds.height));
        }

        this.callback(deltaX, deltaY, starting);
    }

    onMouse(el, e, starting) {
        if ((e.buttons === undefined ? e.which : e.buttons) === 1) {
            this.onMove(el, e, e, starting);
        } else {
            this.dragging = false;
        }
    }

    onTouch(el, e, starting) {
        if (e.touches.length === 1) {
            this.onMove(el, e, e.touches[0], starting);
        } else {
            this.dragging = false;
        }
    }

    onCancel(el, e) {
        if (e.cancelable) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.dragging = false;
    }

    addListener(target, event, listener) {
        target.addEventListener(event, listener, { passive: false });
        this.domEvents.push({ target, event, listener });
    }

    enable(el) {
        this.addListener(el, "mousedown", (e) => this.onMouse(el, e, true));
        this.addListener(window, "mousemove", (e) => this.onMouse(el, e, false));
        this.addListener(window, "mouseup", (e) => this.onCancel(el, e));
        this.addListener(el, "touchstart", (e) => this.onTouch(el, e, true));
        this.addListener(el, "touchmove", (e) => this.onTouch(el, e, false));
        this.addListener(el, "touchend", (e) => this.onCancel(el, e));
        this.addListener(el, "touchcancel", (e) => this.onCancel(el, e));
    }

    destroy() {
        while (this.domEvents.length > 0) {
            const evt = this.domEvents.shift();
            evt.target.removeEventListener(evt.event, evt.listener, false);
        }
    }
}
